import classNames from 'classnames';
import './Video.less';

export const ASPECT_RATIO_1x1 = '1x1';
export const ASPECT_RATIO_16x9 = '16x9';
export const ASPECT_RATIO_4x3 = '4x3';
export const ASPECT_RATIO_21x9 = '21x9';

const allowedRatios = new Set([
  ASPECT_RATIO_1x1,
  ASPECT_RATIO_16x9,
  ASPECT_RATIO_4x3,
  ASPECT_RATIO_21x9,
]);

const Video = ({ children, ratio, className, ...props }) => {
  const ratioClass = allowedRatios.has(ratio)
    ? `ratio ratio-${ratio}`
    : "";

  return (
    <div className={classNames(className, ratioClass)}>
      <video
        className="Video video-preview"
        controls
        controlsList="nodownload"
        {...props}
      >
        {children}
      </video>
    </div>
  );
};


export default Video;